// frontend/src/themes/palettes/oceano.js
import { sharedComponents } from "./shared";
export default {
  muiMode: "light",
  scrollbarColor: "#8FCBD6",
  palette: {
    primary:    { main: "#0E7490" },
    secondary:  { main: "#06B6D4" },
    background: { default: "#EFF9FB", paper: "#FFFFFF" },
    text:       { primary: "#134E5A", secondary: "#4A6E78" },
    divider:    "#CFE8ED",
    action:     { hover: "rgba(14,116,144,0.05)", selected: "rgba(14,116,144,0.09)" },
  },
  components: {
    ...sharedComponents,
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 6, backgroundColor: "#FFFFFF" },
        notchedOutline: { borderColor: "#A8D8E0" },
      },
    },
  },
  custom: {
    chat: { sentBg: "#D3F1F5", quotedSentBg: "#BCE7ED", quotedReceivedBg: "#EAF6F8", accent: "#0E7490", contactAccent: "#06B6D4" },
    chartPalette: ["#0E7490", "#06B6D4", "#F97316", "#FBBF24", "#3B82F6", "#14B8A6"],
    login: { bg: "#EFF9FB" },
  },
};
